import React, { useEffect, useRef, useState, forwardRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import SweetAlert2 from 'react-sweetalert2';
import apiService from './../../Auth/apiService';
import { FaTasks, FaEraser } from 'react-icons/fa';
import { useAuth } from './../../Auth/AuthContext';
import DatePicker from 'react-datepicker';

const CustomFilterInput = forwardRef(({ value, onClick }, ref) => (
  <button
    type="button"
    className="custom-input"
    onClick={onClick}
    ref={ref}
    aria-label="Seleccionar fecha"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      border: 'none',
      background: 'none',
      padding: 0,
      width: '100%',
    }}
  >
    <input
      value={value}
      readOnly
      className="widthCalendar"
      style={{
        pointerEvents: 'none',
        background: '#fff',
        border: '1px solid #ced4da',
        padding: '6px 8px',
        borderRadius: 4,
        width: '100%',
      }}
    />
  </button>
));

export default function Actividades() {
  const navigate = useNavigate();
  const { token, rol, user } = useAuth();
  const { organizacionId } = useParams();
  const [swalProps, setSwalProps] = useState({});
  const [Cargando, setCargando] = useState(false);
  const [actividades, setActividades] = useState([]);
  const [filtros, setFiltros] = useState({
    texto: '',
    evento: '',
    fecha: '',
  });
    const confirmarEliminarResolverRef = useRef(null);
    const confirmarEliminarDecisionRef = useRef(null);
   
  function handleEdit (row){
    navigate(`/organizaciones/${organizacionId}/formularioactividad/${row.id}`);
  };

  useEffect(() => {
    fetchActividades(organizacionId);
  }, [organizacionId]);

  const Mensaje = (title, text) => {
      setSwalProps({
        show: true,
        title: title,
        text: text,
    });
  };
  async function fetchActividades (id) {
      setCargando(true);
      try {
        const response = await apiService.get(`/organizaciones/obteneractividades/${id}`, token);
        setActividades(response.data);
      } catch (error) {
        if (error.response?.data?.message) {
          Mensaje('Actividades', error.response.data.message);
        } else {
          console.error(error);
          Mensaje('Actividades', 'No se pudo cargar las actividades');
        }
      } finally {
        setCargando(false);
      }
    };

  const actividadesFiltradas = actividades.filter((row) => {
    const textoBusqueda = filtros.texto.trim().toLowerCase();
    const eventoBusqueda = filtros.evento.trim().toLowerCase();
    const fechaBusqueda = filtros.fecha.trim();

    const coincideTexto = !textoBusqueda || [
      row.id,
      row.tip_evento,
      row.act_observacion,
      row.act_filename,
      row.act_valor,
    ]
      .filter(Boolean)
      .some((valor) => String(valor).toLowerCase().includes(textoBusqueda));

    const coincideEvento = !eventoBusqueda || String(row.tip_evento ?? '').toLowerCase().includes(eventoBusqueda);
    
    const coincideFecha = !fechaBusqueda || String(row.act_fecha ?? '').slice(0, 10) === fechaBusqueda;

    return coincideTexto && coincideEvento && coincideFecha;
  });

  function mensajeEliminar(title, text) {
        return new Promise((resolve) => {
            confirmarEliminarResolverRef.current = resolve;
            confirmarEliminarDecisionRef.current = null;
            setSwalProps({
            show: true,
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
              confirmarEliminarDecisionRef.current = true;
              return true;
            },
            });
        });
    }
    async function eliminarActividad (row) {
      const confirmEliminar = await mensajeEliminar("Eliminar", `¿Está seguro de que desea eliminar a ${row.tip_evento}?`);
      if (!confirmEliminar) {
          return;
      }
      setCargando(true);
      const url = '/organizaciones/eliminaractividad';
      const obj = {
          id: row.id,
          usrId: user,
      };
      try {
          const response = await apiService.post(url, obj, token);
          if(response.status === 200){
            await fetchActividades(organizacionId);
              Mensaje('Eliminar', JSON.stringify(response.data.message));
          }
      } catch (error) {
          if(error.status === 422){
              Mensaje('Eliminar', JSON.stringify(error.response.data.errors));
          }else if(error.status === 409){
              Mensaje('Eliminar', JSON.stringify(error.response.data.message));
          }else{
            Mensaje('Eliminar', error.response?.data?.message ? JSON.stringify(error.response.data.message) : 'Ocurrió un error inesperado.')
          }
      } finally {
          setCargando(false);
      }
  }


  return (
        
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Lista actividades organizaciones</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><a href="/organizaciones/listar"> Organizaciones</a></li>
                        <li className="breadcrumb-item active">Actividades</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section>
              <div className="container-fluid">               
                <section className="content">
                    <div className="container-fluid">
                          {Cargando && <div className="centered">
                            <div><progress value={null} /></div>
                          </div>}
                          
                    </div>
                </section>
                <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-header">
                          <div className="card-tools">
                            <div className="row">
                                <div className="col-md-6">
                                    <button
                                        type="button"
                                        className="btn btn-block btn-secondary"
                                        style={{
                                            backgroundColor: '#6c757d',
                                            color: 'white',
                                            padding: '6px 12px',
                                            fontSize: '1rem',
                                            borderRadius: '6px',
                                            border: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                        onClick={() => navigate(`/organizaciones/listar`)}
                                    >
                                        Volver
                                    </button>
                                </div>
                              <div className="col-md-6">
                                <button
                                    type="button"
                                    className="btn btn-block btn-primary"
                                    style={{
                                        backgroundColor: 'skyblue',
                                        color: 'black', // Font color black
                                        padding: '6px 12px',         // Smaller padding
                                        fontSize: '1rem',            // Smaller font size
                                        borderRadius: '6px',         // Slightly smaller radius
                                        border: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={() => navigate(`/organizaciones/${organizacionId}/formularioactividad/0`)}
                                >
                                    Crear
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                          <div className="p-3 border-bottom bg-light">
                            <div className="row">
                              <div className="col-md-4 mb-2">
                                <label htmlFor="filtroTexto">Buscar</label>
                                <input
                                  id="filtroTexto"
                                  type="text"
                                  className="form-control"
                                  placeholder="Id, evento, archivo, observación o valor"
                                  value={filtros.texto}
                                  onChange={(e) => setFiltros((prev) => ({ ...prev, texto: e.target.value }))}
                                />
                              </div>
                              <div className="col-md-4 mb-2">
                                <label htmlFor="filtroEvento">Evento</label>
                                <input
                                  id="filtroEvento"
                                  type="text"
                                  className="form-control"
                                  placeholder="Filtrar por evento"
                                  value={filtros.evento}
                                  onChange={(e) => setFiltros((prev) => ({ ...prev, evento: e.target.value }))}
                                />
                              </div>
                              <div className="col-md-2 mb-2">
                                <label htmlFor="filtroFecha">Fecha</label>
                                <DatePicker
                                  id="filtroFecha"
                                  selected={filtros.fecha ? new Date(`${filtros.fecha}T12:00:00`) : null}
                                  onChange={(date) => {
                                    const fechaFormateada = date
                                      ? new Date(date.setHours(12, 0, 0, 0)).toISOString().slice(0, 10)
                                      : '';
                                    setFiltros((prev) => ({ ...prev, fecha: fechaFormateada }));
                                  }}
                                  dateFormat="yyyy-MM-dd"
                                  className="form-control"
                                  customInput={<CustomFilterInput />}
                                />
                              </div>
                              <div className="col-md-1 d-flex align-items-end mb-2">
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary w-100"
                                  onClick={() => setFiltros({ texto: '', evento: '', fecha: '' })}
                                >
                                  Limpiar
                                </button>
                              </div>
                            </div>
                          </div>
                          <table className="table table-bordered table-hover">
                              <thead>
                                  <tr>
                                      <th>Acciones</th>
                                      <th>Id</th>
                                      <th>Fecha</th>
                                      <th>Evento</th>
                                      <th>Valor</th>
                                      <th>Archivo</th>
                                      <th>Observacion</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {actividadesFiltradas.length === 0 ? (
                                      <tr>
                                          <td colSpan="7" className="text-center">
                                        No hay actividades para mostrar con los filtros actuales
                                          </td>
                                      </tr>
                                  ) : (
                                    actividadesFiltradas.map((row, idx) => (
                                          <tr key={row.id || idx}>
                                              <td>
                                                  <div style={{ display: 'flex', gap: 8 }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleEdit(row)}
                                                        style={{
                                                            backgroundColor: 'skyblue',
                                                            padding: '10px 14px',
                                                            fontSize: '1.1rem',
                                                            borderRadius: '8px',
                                                            border: 'none',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        data-tooltip-id='tooltiparriba'
                                                        data-tooltip-content="Ver datos de la actividad"
                                                    >
                                                        <FaTasks />
                                                    </button>
                                                    {rol === '2' && 
                                                        <button
                                                            type="button"
                                                            onClick={() => eliminarActividad(row)}
                                                            style={{
                                                                backgroundColor: 'red',
                                                                padding: '10px 14px',
                                                                fontSize: '1.1rem',
                                                                borderRadius: '8px',
                                                                border: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            data-tooltip-id='tooltiparriba'
                                                            data-tooltip-content="Eliminar actividad"
                                                        >
                                                            <FaEraser />
                                                        </button>
                                                    }
                                                  </div>
                                              </td>
                                              <td>{row.id}</td>
                                              <td>{row.act_fecha}</td>
                                              <td>{row.tip_evento}</td>
                                              <td>{row.act_valor}</td>
                                              <td>{row.act_filename}</td>
                                              <td>{row.act_observacion}</td>

                                          </tr>
                                      ))
                                  )}
                              </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        if (confirmarEliminarResolverRef.current) {
                          confirmarEliminarResolverRef.current(Boolean(confirmarEliminarDecisionRef.current));
                          confirmarEliminarResolverRef.current = null;
                          confirmarEliminarDecisionRef.current = null;
                        }
                        setSwalProps({})
                    }}/>
                <Tooltip id="tooltiparriba" place="right"/>
              </div>
            </section>
        </div>
        
        
    )
  }